"use strict";

jQuery(document).ready(function ($) {
  /**
   * Scrollbar width
   */
  getScrollbarWidth();
  $(window).resize(getScrollbarWidth);

  function getScrollbarWidth() {
    var $body = $('body');
    var scrollbar = window.innerWidth - $body[0].clientWidth;
    $body.css('--scrollbar', "".concat(scrollbar, "px"));
  }
  /**
   * Smooth Scroll
   */


  $(document).on('click', '.js a.scroll[href*="#"], a[href*="#"]', function (event) {
    // On-page links
    if (this.hash.length > 0 && location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if ($(this).hasClass('no-scroll')) {
        return;
      } // Does a scroll target exist?


      if (target.length) {
        var scrollPadding = $('html').css('scroll-padding-top');
        $('html, body').animate({
          scrollTop: target.offset().top - parseInt(scrollPadding)
        }, 1000);
      }
    }
  });
  /**
   * Social Share
   */

  $('.c-share a').click(function (event) {
    var width = 500;
    var height = 300;
    var url = $(this).attr('href');
    var left = screen.width / 2 - width / 2;
    var top = screen.height / 2 - height / 2;
    window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
    event.preventDefault();
  });
});
jQuery(document).ready(function ($) {
  /**
   * Calculate Prefooter image width
   */
  imageWidth();
  $(window).resize(imageWidth);

  function imageWidth() {
    var $lastMenuItem = $('.m-header-nav-menu--secondary .menu-item:last-child .menu-item-link');
    var lastMenuItemWidth = $lastMenuItem.width();
    var lastMenuItemOffset = $lastMenuItem.offset().left;
    $('html').css('--prefooter-image-width', "".concat(lastMenuItemWidth + lastMenuItemOffset, "px"));
  }
});
jQuery(document).ready(function ($) {
  var desktopBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-value-lg'));
  var $header = $('.m-header');
  /**
   * Calculate Header Height
   */

  headerHeight();
  $(window).resize(headerHeight);

  function headerHeight() {
    var _$adminBar$height;

    var $adminBar = $('#wpadminbar');
    var adminBarHeight = (_$adminBar$height = $adminBar.height()) !== null && _$adminBar$height !== void 0 ? _$adminBar$height : 0; // const height = $header.height() + adminBarHeight;

    var height = $header.height();
    $('html').css('--admin-bar-height', "".concat(adminBarHeight, "px"));
    $('html').css('--header-height', "".concat(height, "px"));
    $('html').css('--header-offset-left', "".concat($('.m-header-logo').offset().left, "px")); // $('.m-header-nav').css('--header-height', `${$header.height()}px`);
  }
  /**
   * Announcement Bar
   */


  manageAnnouncementBar();

  function manageAnnouncementBar() {
    var $announcement = $('.m-announcement-bar');

    if (!$announcement.length) {
      return;
    }

    var height = $announcement.height();
    $('body').css('--announcement-height', "".concat(height, "px"));
    var announcement_id = $announcement.data('announcement');
    var $close = $('.m-announcement-bar-close');
    $close.click(function (event) {
      Cookies.set("announcement-".concat(announcement_id), true, {
        expires: 31,
        secure: true
      });
      $announcement.slideUp(400, function () {
        $('body').css('--announcement-height', '');
        headerHeight();
      });
      event.preventDefault();
    });
  }
  /**
   * Check colors
   */


  var currentBackgroundColor = $header.css('--header-topbar-background');

  if ('transparent' == currentBackgroundColor) {
    $header.addClass('transparent-background');
  }
  /**
   * Change on scroll
   */


  var scroll = $(this).scrollTop();
  var toggleClass = false;

  if (scroll > 10) {
    toggleClass = true;
  }

  $('.m-header').toggleClass('scrolled', toggleClass);
  $('.m-header-logo-wordmark').toggleClass('hide', toggleClass);
  $(window).scroll(function () {
    scroll = $(this).scrollTop();
    toggleClass = false;

    if (scroll > 10) {
      toggleClass = true;
      $header.removeClass("transparent-background");
    } else {
      window.requestAnimationFrame(function () {
        var currentBackgroundColor = $header.css("--header-topbar-background");

        if ("transparent" == currentBackgroundColor) {
          $header.addClass("transparent-background");
        }
      });
    }

    $(".m-header").toggleClass("scrolled", toggleClass);
    $(".m-header-logo-wordmark").toggleClass("hide", toggleClass);
  });
  /**
   * Hamburger button
   */

  var menuOpened = false;
  $('.m-header-hamburger').click(function (event) {
    menuOpened = !menuOpened;
    var $this = $(this);
    var $nav = $('.m-header-nav');
    $this.toggleClass('is-active');
    $nav.slideToggle(300);
    $this.attr('aria-expanded', menuOpened);
  });
  /**
   * Mega Menu
   */

  var megaMenuActive = false;
  var megaMenuActiveClass = 'active';
  $('.menu-item').hover(function (event) {
    if ($(window).width() < desktopBreakpoint) {
      return;
    }

    var $this = $(this);
    var $megaMenu = $this.find('.mega-menu');

    if ($(event.relatedTarget).hasClass('has-mega-menu')) {
      megaMenuActive = true;
    }

    $this.addClass(megaMenuActiveClass);
    $megaMenu.toggleClass(megaMenuActiveClass, megaMenuActive);

    if ($megaMenu.hasClass(megaMenuActiveClass) && megaMenuActive) {
      $megaMenu.stop(true, true).show();
    } else {
      $megaMenu.slideDown(300);
    }

    megaMenuActive = true;
  }, function (event) {
    if ($(window).width() < desktopBreakpoint) {
      return;
    }

    var $this = $(this);
    var $megaMenu = $this.find('.mega-menu');
    megaMenuActive = $megaMenu.length && $(event.relatedTarget).hasClass('has-mega-menu');
    $this.removeClass(megaMenuActiveClass);
    $megaMenu.toggleClass(megaMenuActiveClass, megaMenuActive);

    if ($megaMenu.hasClass(megaMenuActiveClass)) {
      $megaMenu.stop(true, true).hide();
    } else {
      $megaMenu.stop(true, true).slideUp(300);
    }
  });
  $('.menu-item.has-mega-menu .menu-item-link').click(function (event) {
    if ($(window).width() >= desktopBreakpoint) {
      return;
    }

    var $this = $(this);
    var $megaMenu = $this.parent().find('.mega-menu');
    $this.toggleClass('is-active');
    $megaMenu.stop(true, true).slideToggle(300);
  });
});
//# sourceMappingURL=app.js.map
